// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"219":"forum/components/ChooseTagsToFollowModal","238":"forum/components/SubscriptionModal"}[chunkId] + ".js";
};